<ion-menu contentId="menu-content">
  <ion-header class="ion-no-border" [class.development]="isDevelopment">
    <ion-toolbar>
      <ion-title>{{ 'menu.title.long' | translate }}</ion-title>
      <ion-title slot="end">{{ this.userStore.firstName() }}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-no-border">
    <ion-list>
      <ion-item lines="none">
        <ion-icon class="icon-size-20" draggable="false" [src]="odsIcons.Home" />
        <ion-label class="showAsLink ion-margin-start" routerLink="/home"
                   (click)="closeMenu()">{{ 'menu.home.short' | translate }}
        </ion-label>
      </ion-item>
      <ion-item-divider />
      <ion-item lines="none">
        <ion-icon class="icon-size-20" draggable="false" [src]="odsIcons.Account" />
        <ion-label class="showAsLink ion-margin-start" routerLink="/account/my-account"
                   (click)="closeMenu()">{{ 'menu.account.short' | translate }}
        </ion-label>
      </ion-item>
      <ion-item-divider />
      <ion-item lines="none">
        <ion-icon class="icon-size-20" draggable="false" [src]="odsIcons.DeviceInfo" />
        <ion-label class="showAsLink ion-margin-start" routerLink="/support/settings"
                   (click)="closeMenu()">{{ 'menu.version.short' | translate }}
        </ion-label>
      </ion-item>
      <ion-item-divider />
      @if (isNotNullOrEmpty(this.deploymentStore.deploymentList())) {
        <ion-item lines="none">
          <ion-icon class="icon-size-20" draggable="false" [src]="odsIcons.DeploymentList" />
          <ion-label class="showAsLink ion-margin-start" routerLink="/port-mappings"
                     (click)="closeMenu()">{{ 'menu.popMapping.short' | translate }}
          </ion-label>
        </ion-item>
      }
      <ion-item-divider />
      <ion-item class="showAsLink" lines="none" (click)="presentTenantDeploymentModal();closeMenu()">
        <ion-icon class="icon-size-20" draggable="false" [src]="odsIcons.DeploymentSelect" />
        <ion-label class=" ion-margin-start">
          <sub>{{ (this.deploymentStore.selectedTenant()?.name ?? 'Click here to set your deployment') }}</sub>
          <br /> {{ (this.deploymentStore.selectedDeployment()?.name) }}
        </ion-label>
      </ion-item>
      @if (this.deploymentStore.hasDeploymentSelected()) {
        <ion-item-divider />
        <ion-item lines="none">
          <ion-icon class="icon-size-20" draggable="false" name="code-download-outline" />
          <ion-label class="showAsLink ion-margin-start" routerLink="/support/device-status"
                     (click)="closeMenu()">{{ 'menu.device.short' | translate }}
          </ion-label>
        </ion-item>
      }
    </ion-list>
  </ion-content>
  <ion-footer class="showAsLink footer-margin background-cloudotdr" (click)="logOut();closeMenu()">
    <ion-item class="background-cloudotdr" lines="none">
      <ion-icon class="background-cloudotdr" color="primary" name="log-out-outline" slot="start" />
      <ion-label class="background-cloudotdr">{{ 'menu.logout.short' | translate }}</ion-label>
    </ion-item>
  </ion-footer>
</ion-menu>
<ion-router-outlet id="menu-content" />
<ods-notification-progress />

